<template>
  <div class="lives-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入活动名称/商家名称"></Input>
        </FormItem>
        <FormItem>
          <FormItem>
            <DatePicker type="datetimerange"
                        format="yyyy-MM-dd"
                        :value="datePic"
                        @on-change="changeDate"
                        style="width: 200px"
                        placeholder="开始时间 - 结束时间"></DatePicker>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.area1"
                    clearable
                    placeholder="省"
                    @on-change="shengChange">
              <Option v-for="item in shengList"
                      :value="item.id"
                      :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.area2"
                    clearable
                    placeholder="市"
                    @on-change="shiChange">
              <Option v-for="item in shiList"
                      :value="item.id"
                      :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.area3"
                    clearable
                    placeholder="县">
              <Option v-for="item in quList"
                      :value="item.id"
                      :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="审核"
            v-model="showModalStatus"
            width="60"
            scrollable
            @on-ok="createuser('userValidate')"
            :loading="loading"
            :mask-closable="false">
      <List>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">活动商家名称:</span>
                {{dataInfo.tradesman_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">关键字:</span>
                {{dataInfo.keyword }}
              </label>
            </li>
          </template>
        </ListItem>
        <!-- <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">推荐封面图:</span>
            </label>
            <img :src="$publicData.ossUrl +dataInfo.push_thumb"
                 style="width: 420px;height: 232px;" />
            </Col>
          </Row>
        </ListItem> -->
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">封面图:</span>
            </label>
            <!--<Avatar shape="square" icon="ios-person" size="large" :src="dataInfo.thumb" width="100"/>-->
            <img :src="$publicData.ossUrl +dataInfo.thumb"
                 style="width: 200px;height: 200px;" />
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">图集:</span>
            </label>
            <div v-if="dataInfo.album!=null&&dataInfo.album!=''">
              <img v-for="(item,key) in dataInfo.album.split(',')"
                   :src="$publicData.ossUrl +item"
                   style="width: 200px;height: 200px;" />
              <!--<Avatar v-for="(item,key) in dataInfo.album.split(',')" shape="square" icon="ios-person" size="large" :src="item"/>-->
            </div>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">详细地址:</span>
              {{ dataInfo.area1_name }} {{ dataInfo.area2_name }} {{ dataInfo.area3_name }}{{
                dataInfo.address }}
            </label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">举办时间:</span>
              {{ dataInfo.starttime }} -- {{ dataInfo.endtime }}
            </label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">内容:</span>
            <label style="font-size: 14px;"
                   v-html="dataInfo.content"></label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">购票须知:</span>
            <label style="font-size: 14px;"
                   v-html="dataInfo.notice "></label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Table border
                   :columns="ticket_list"
                   :data="tableTicketlist"
                   :loading="dataloading"></Table>
          </Row>
        </ListItem>
        <Form :model="editInfo"
              ref="editInfoValidate"
              :rules="editInfoValidate"
              action="javascript:void(0)">
          <ListItem>
            <FormItem label="是否推荐"
                      prop="pos_flag">
              <RadioGroup v-model="editInfo.pos_flag">
                <Radio :label="0"
                       border>否</Radio>
                <Radio :label="1"
                       border>是</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="排序"
                      prop="sort">
              <Input v-model="editInfo.sort"
                     placeholder="排序"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="审核"
                      prop="status">
              <RadioGroup v-model="editInfo.status">
                <Radio :label="-1"
                       border>不通过</Radio>
                <Radio :label="1"
                       border>通过</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="审核备注"
                      prop="remark">
              <Input type="textarea"
                     v-model="editInfo.remark"
                     placeholder="输入审核备注..."
                     :autosize="{minRows:4,maxRows:8}"></Input>
            </FormItem>
          </ListItem>
          <div class="demo-drawer-footer">
            <Button type="primary"
                    @click="createOrUpdate('editInfoValidate')">提交</Button>
          </div>
        </Form>
      </List>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "lives-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      datePic: [],
      thumblist: [],
      tableTicketlist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "title",
          minWidth: 200
        },
        {
          title: "商家名称",
          key: "title",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tradesman != null
                  ? params.row.tradesman.nickname
                  : ""
              )
            ]);
          }
        },
        {
          title: "类型",
          key: "title",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.type != null ? params.row.type.title : ""
              )
            ]);
          }
        },
        {
          title: "封面图",
          key: "headimgurl",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large"
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "地区",
          key: "headimgurl",
          width: 90,
          render: (h, params) => {
            var p_name =
              params.row.provice != null ? params.row.provice.areaname : "";
            var c_name =
              params.row.city != null ? params.row.city.areaname : "";
            var a_name =
              params.row.area != null ? params.row.area.areaname : "";
            return h("div", [
              h("span", {}, p_name + c_name + a_name + params.row.address)
            ]);
          }
        },
        {
          title: "价格",
          key: "price",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  attrs: {
                    style: "color:red"
                  }
                },
                "¥" + params.row.price
              )
            ]);
          }
        },
        {
          title: "开始时间",
          key: "starttime",
          width: 150
        },
        {
          title: "结束时间",
          key: "endtime",
          width: 150
        },
        // {
        //   title: "检查时间",
        //   key: "checkouttime",
        //   width: 150
        // },
        {
          title: "最少参与人数",
          key: "num_people",
          width: 90
        },
        {
          title: "状态",
          width: 90,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.status == 1
                  ? "通过"
                  : params.row.status == 0
                    ? "未审核"
                    : "未通过"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      ticket_list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "排序",
          width: 90,
          key: "sort"
        },
        {
          title: "场次标题",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [h("span", {}, params.row.field.title)]);
          }
        },
        {
          title: "价格",
          key: "price",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  attrs: {
                    style: "color:red"
                  }
                },
                "¥" + params.row.price
              )
            ]);
          }
        },
        {
          title: "至少参加人数",
          width: 120,
          key: "num_people"
        },
        {
          title: "库存",
          width: 120,
          key: "store"
        },

        {
          title: "销量",
          width: 120,
          key: "sales"
        },
        {
          title: "状态",
          width: 90,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 1 ? "在售" : "禁用")
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      shengList: [],
      shiList: [],
      quList: [],
      editInfo: {
        remark: "",
        pos_flag: 0,
        status: 1,
        sort: 0
      },
      editInfoValidate: {
        status: [
          {
            required: true,
            message: "审核状态必须填写",
            trigger: "change",
            type: "integer"
          }
        ]
      },
      thumblist: [],
      thumblistTwo: [],
      shengList: [],
      shiList: [],
      quList: [],
      key_params: {
        datetime: [],
        datetimeTwo: ""
      },
      dataInfo: {
        title: "",
        live_type: "",
        describe: "",
        price: "",
        thumb: "",
        area1: "",
        area2: "",
        area3: "",
        address: "",
        starttime: "",
        endtime: "",
        checkouttime: "",
        num_people: "",
        content: "",
        notice: "",
        pos_flag: "",
        album: "",
        is_fx: "",
        fx: "",
        sort: "",
        merchant_sort: "",
        status: ""
      },
      livetypeList: [],
      isClear: false,
      params: {
        starttime: "",
        endtime: "",
        checkouttime: ""
      }
    };
  },
  // 组件
  components: {},
  created: function () {
    // 取数据
    this.getTableList();
    this.getShengList();
  },
  methods: {
    getTableList: function () {
      this.$api.lives
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.editInfo = {
        remark: "",
        pos_flag: 0,
        status: 1,
        sort: 0
      };
      this.$api.lives.detail({ id: id }).then(res => {
        this.showModalStatus = !this.showModalStatus;
        this.dataInfo = res.result;
        this.dataInfo.tradesman_name =
          res.result.tradesman == "" && res.result.tradesman.nickname == ""
            ? ""
            : res.result.tradesman.nickname;
        this.dataInfo.area1_name = res.result.provice.areaname;
        this.dataInfo.area2_name = res.result.city.areaname;
        this.dataInfo.area3_name = res.result.area.areaname;
        this.dataInfo.pos_flag_name = res.result.pos_flag == 1 ? "是" : "否";
        this.tableTicketlist = res.result.ticket;
        this.editInfo.id = this.dataInfo.id;
        this.editInfo.remark = this.dataInfo.remark;
        this.editInfo.pos_flag = this.dataInfo.pos_flag;
        this.editInfo.status = this.dataInfo.status;
        this.editInfo.sort = this.dataInfo.sort;
      });
    },
    // 添加
    createOrUpdate (name) {
      console.log(this.editInfo);
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.lives.status(this.editInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    changeDate (val) {
      this.key_params.datetime = val;
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.lives.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var bgn_date =
        this.key_params.datetime[0] != undefined
          ? this.key_params.datetime[0]
          : "";
      var end_date =
        this.key_params.datetime[1] != undefined
          ? this.key_params.datetime[1]
          : "";
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        starttime: bgn_date,
        endtime: end_date,
        area1: this.formItem.area1,
        area2: this.formItem.area2,
        area3: this.formItem.area3
      };
      this.$api.lives.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
</style>
